<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
  @import "./assets/css/main.css";
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  /*margin-top: 60px;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue